import { setCoreAuthToken } from 'api/CoreInstance';
import { KEYS_LOCALSTORAGE } from 'constants/general';
import ResponseHandlerService from './ResponseHandlerService';
import { BehaviorSubject } from 'rxjs';
import CoreApi from '../api/core';
import { isTeacher } from 'lib/helpers';
import groupEndpoints from '../api/resources/group';

interface IAssignActivity {}

class AssignActivityService {
  static instance: AssignActivityService;
  private centers$: BehaviorSubject <any[]> ;
  private centerConfiguration$: BehaviorSubject <any[]>;
  private responseHandler = ResponseHandlerService.getInstance();

  constructor() {
    this.centers$ = new BehaviorSubject <any>([]);
    this.centerConfiguration$ = new BehaviorSubject <any>([]);
  }

  static getInstance(): AssignActivityService {
    if (!AssignActivityService.instance)
      AssignActivityService.instance = new AssignActivityService();
    return AssignActivityService.instance;
  }

  getCenters = () => this.centers$;
  getCenterConfiguration = () => this.centerConfiguration$;

  fetchCenters = () => {
    const userType = localStorage.getItem('user_type') || '';
    const organizationUsers = ['Admin', 'Owner', 'Director'];

    if (organizationUsers.includes(userType)) {
      setCoreAuthToken(localStorage.getItem(KEYS_LOCALSTORAGE.ACCOUNT_TOKEN));
    } else {
      setCoreAuthToken(localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVE_CENTER_TOKEN));
    }

    return CoreApi.organizationScope.getCentersAssignActivity()
    .then((response: any) => {
      let data = [];
      if(isTeacher()) {
        data.push(response.center);
      } else {
        data = response;
      }
      const buildCenters = data.map((center: any) => {
        return {
          ...center,
          ...{
            label: center.name,
            value: center.id,
            groups: center.groups.map((group: any) => {
              return {
                ...group,
                ...{
                  label: group.name,
                  value: group.id,
                }
              }
            })
          }
        }
      })
      this.centers$.next(buildCenters);
      return data;
    })
  };

  fetchCenterConfiguration = () => {
    setCoreAuthToken(localStorage.getItem(KEYS_LOCALSTORAGE.ACCOUNT_TOKEN));

    return CoreApi.organizationScope.getCenterConfiguration()
    .then(({ organization_configuration, center_configuration }: any) => {
      this.centerConfiguration$.next(organization_configuration || center_configuration);
      return organization_configuration;
    });
  }

  scheduleActivity = (body: any) => groupEndpoints.postScheduleActivity(body);

  removeActivity = (activityId: number, groupId: number, skillProgrammeId: number) =>
    CoreApi.centerScope.removeActivity(activityId, groupId, skillProgrammeId);
}

export default AssignActivityService;
